import { Box, CircularProgress } from '@mui/material';
import { ContractSummary } from 'customer-management/customer-details/contract-summary/contractSummary';
import { CustomerInfoWidget } from 'customer-management/customer-details/customer-info-widget';
import { ViewContractsResolver } from 'customer-management/customer-details/view-contracts/view-contracts-resolver';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useUserPermissions } from 'shared/hooks';

interface ICustomerDetailsRoutesProps {
  isLoading: boolean;
}

export function CustomerDetailRoutes({
  isLoading
}: ICustomerDetailsRoutesProps) {
  const { path } = useRouteMatch();
  const userPermissions = useUserPermissions();
  const hasControllerPermission = userPermissions.includes('abg-retail.controller');
  return (
    <Switch>
      <Route path={`${path}/contractSummary`} exact>
        <Box paddingTop={2} paddingBottom={2}>
          <CustomerInfoWidget />
        </Box>
        {
          hasControllerPermission ?
            <Box p={2}>
              {
                isLoading ?
                  <CircularProgress /> :
                  <>No contracts have been entered or approved</>
              }
            </Box> :
            <>
              <ContractSummary />
            </>
        }
      </Route>
      <Route path={`${path}/viewContract/:contractId`}>
        <Box paddingTop={2} paddingBottom={2}>
          <CustomerInfoWidget />
        </Box>
        <ViewContractsResolver />
      </Route>
    </Switch>
  );
}
